import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface FilterItem {
  id: any;
  title: string;
  checked: boolean;
  index?: number;
}

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent {
  @Input() set items(items: FilterItem[]) {
    if (!items) {
      return;
    }

    this._originItems = JSON.parse(JSON.stringify(items));
    this._items = JSON.parse(JSON.stringify(items));

    this._originItems.forEach((item, i) => {
      item.checked = true;
      item.index = i;
    });

    this._items.forEach((item, i) => {
      item.checked = true;
      item.index = i;
    });
  }
  get items(): FilterItem[] {
    return this._items;
  }
  @Input() column: string;
  @Input() sortDisabled: string;

  @Output() action = new EventEmitter<{
    type: 'onSortLabelClick' | 'closeFilterMenu';
    isSortOrderDesc?: boolean;
    checkedItems?: string[];
  }>();

  public _items: FilterItem[];
  public _originItems: FilterItem[];
  public isDisabledFilteringButton = true;
  public keyword: string;

  setAllCheckboxes(checked: boolean): void {
    this.isDisabledFilteringButton = false;
    this._items.forEach((item) => (item.checked = checked));
  }

  checkChanged(checked: boolean, index: number): void {
    this.isDisabledFilteringButton = false;
    this._items[index].checked = checked;
  }

  sort(isSortOrderDesc: boolean): void {
    this.keyword = null;
    this.isDisabledFilteringButton = true;

    this.action.emit({
      type: 'onSortLabelClick',
      isSortOrderDesc,
      checkedItems: this._originItems
        .filter((item) => item.checked)
        .map((item) => item.id),
    });
  }

  ok(): void {
    this.keyword = null;
    this.isDisabledFilteringButton = true;

    this.action.emit({
      type: 'closeFilterMenu',
      checkedItems: this._items
        .filter((item) => item.checked)
        .map((item) => item.id),
    });
  }

  cancel(): void {
    this.keyword = null;
    this.isDisabledFilteringButton = true;

    this._items = JSON.parse(JSON.stringify(this._originItems));
  }
}
